import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-examples',
  templateUrl: './examples.component.html',
  styleUrls: ['./examples.component.scss']
})
export class ExamplesComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    @Inject(PLATFORM_ID) private platformId: Object
    ) { }

  ngOnInit() {
    this.titleService.setTitle('AI搭載の校正ツールTrinkaの文法修正サンプル | Trinka');
    this.metaTagService.updateTag({ name: 'description', content: '校正ツールTrinkaは読み手や専門分野に合わせて文書を修正。文法ミスのチェックに加え、文章のトーンや文体、読みやすさ、客観性など、多角的にライティングを改善します。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '文法チェック,学術論文 チェック,テクニカルライティング,アカデミックライティング,英文チェッカー,校正ツール,AI校正ツール,AIツール,学術論文,文法チェック,文法チェックツール,英文　校正　サイト,英文校正　無料,英文チェック　サイト,Trinka,トリンカ' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'AI搭載の校正ツールTrinkaの文法修正サンプル | Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: '校正ツールTrinkaは読み手や専門分野に合わせて文書を修正。文法ミスのチェックに加え、文章のトーンや文体、読みやすさ、客観性など、多角的にライティングを改善します。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/examples' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/examples' });
    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  

}
